import { useState } from "react";
import { useSelector } from "react-redux";
import { PendingCardSkeletons } from "../../utils/skeleton";
import DocsIcon from "../../assets/icons/leave_icons/docs.svg";
import ApproveStatusIcon from "../../assets/icons/approve_status.svg";
import RejectStatusIcon from "../../assets/icons/reject_status.svg";
import PendingStatusIcon from "../../assets/icons/pending_status.svg";
import CancelStatusIcon from "../../assets/icons/cancel_status.svg";
import MessageModal from "../../commonComponents/messageModal";
import LoginIcon from "../../assets/icons/login.svg";
import LogoutIcon from "../../assets/icons/logout.svg";
import NothingIcon from "../../assets/images/task-not-found-1 6.png";
import moment from "moment";
import "./RegularisationHistory.css";

const RegularisationHistory = () => {
  const regularisationHistoryResponse = useSelector(
    (state) => state.attendance.regularisationHistoryResponse?.body || [],
  );
  const regularisationHistoryResponseStatus = useSelector(
    (state) => state.attendance.regularisationHistoryResponseStatus,
  );
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    message: "",
  });
  const empName = useSelector(
    (state) => state?.auth?.loginResponse?.display_name,
  );
  return (
    <div className="rh-history">
      <div className="rh-hs-head">regularisation history</div>
      {regularisationHistoryResponseStatus === "PENDING" && (
        <PendingCardSkeletons />
      )}
      {regularisationHistoryResponseStatus === "SUCCESS" && (
        <div className="rh-hs-list">
          {regularisationHistoryResponse?.length ? (
            regularisationHistoryResponse.map((item, index) => {
              return (
                <div className="rh-hs-item" key={index}>
                  <div className="rh-hs-item-left">
                    <div className="rh-hs-range">
                      <div className="rh-hs-start-wrap">
                        <img src={LoginIcon} alt="" className="rh-log-ico" />
                        <div className="rh-hs-start-text">
                          {`${moment(item?.date).format("DD MMM'YY")} at ${moment(item?.clock_in, "HH:mm:ss").format("hh:mm A")}`}
                        </div>
                      </div>

                      <div className="rh-hs-end-wrap">
                        <img src={LogoutIcon} alt="" className="rh-log-ico" />
                        <div className="rh-hs-end-text">{`${moment(item?.clock_out_date).format("DD MMM'YY")} at ${moment(item?.clock_out, "HH:mm:ss").format("hh:mm A")}`}</div>
                      </div>
                    </div>
                  </div>

                  <div className="rh-hs-middle">
                    <div className="rh-hs-type">
                      <div className="rh-hs-type-text">{item?.reason}</div>
                    </div>

                    {/* <div className="rh-hs-reason-text">{item?.reason}</div> */}

                    {item?.s3_url && (
                      <div
                        className="rh-hs-attachment"
                        onClick={() => window.open(item?.s3_url, "_blank")}
                      >
                        <img
                          className="rh-hs-attachment-ico"
                          src={DocsIcon}
                          alt=""
                        />
                        <div className="rh-hs-attachment-text">1</div>
                      </div>
                    )}
                  </div>

                  <div className="rh-hs-right">
                    {item?.employee_comment && (
                      <div
                        className="rh-hs-attachment"
                        onClick={() =>
                          setModalConfig({
                            isOpen: true,
                            message: item.employee_comment,
                          })
                        }
                      >
                        <img
                          className="rh-hs-attachment-ico"
                          src={DocsIcon}
                          alt=""
                        />
                        <div className="rh-hs-attachment-text">1</div>
                      </div>
                    )}
                    {item?.remarks && (
                      <div
                        className="rh-hs-attachment"
                        onClick={() =>
                          setModalConfig({
                            isOpen: true,
                            message: item.remarks,
                          })
                        }
                      >
                        <img
                          className="rh-hs-attachment-ico"
                          src={DocsIcon}
                          alt=""
                        />
                        <div className="rh-hs-attachment-text">1</div>
                      </div>
                    )}
                    <div
                      className={`leave-hs-status-wrap leave-hs-status-${item?.approval_status?.toLowerCase()}`}
                    >
                      <img
                        src={
                          item?.approval_status?.toLowerCase() === "approved"
                            ? ApproveStatusIcon
                            : item?.approval_status?.toLowerCase() ===
                                  "rejected" ||
                                item?.approval_status?.toLowerCase() ===
                                  "revoked"
                              ? RejectStatusIcon
                              : item?.approval_status?.toLowerCase() ===
                                  "cancel"
                                ? CancelStatusIcon
                                : PendingStatusIcon
                        }
                        alt=""
                        className="leave-hs-status-icon"
                      />
                      <div className="leave-hs-status-text">
                        {item?.approval_status}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="flex flex-col items-center justify-center h-full w-full">
              <img className="rp-empty-ico" src={NothingIcon} alt="" />
              <div className="rp-empty-text">No data available</div>
            </div>
          )}
        </div>
      )}
      <MessageModal
        isOpen={modalConfig.isOpen}
        onClose={() => setModalConfig({ ...modalConfig, isOpen: false })}
        message={modalConfig.message}
        empName={empName}
      />
    </div>
  );
};

export default RegularisationHistory;
